module.exports = __webpack_public_path__ + "img/wsxx.078af31e.jpg";